import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import NumberFormat from 'react-number-format';
import { pathOr } from "ramda";


const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: "0.875rem !important",
        padding: "4px 8px !important",
    },
    body:{
        padding: "8px 8px !important",
        fontSize: "0.875rem",
    }
}))(TableCell);

const useStyles = makeStyles({
    table: {
        minWidth: 650,
        border: "#cccccc43 solid thin",
    },
});
export default function Lineitemdetailview({ data }) {
    const classes = useStyles();
    const [linedata, setLinedata] = useState(data);
    const config = useSelector((state) => state.config);
    //const currencyId = pathOr([], ['userPreference','attributes', 'global', 'currency'], config);
    const currencyArray = pathOr([], ['userPreference','attributes', 'CurrenciesRecords'], config);
    
    // console.log("linedata--->",linedata);
    const getData = pathOr([], ["simple_data", "data"], linedata);
    const currencyId = pathOr([], ["simple_data", "data","0","currency_id"], linedata);

    var serviceExist = getData.some(function (e) {
        return e.line_type === "service";
    });
    var productExist = getData.some(function (e) {
        return e.line_type === "product";
    });
    /*var currencyId = getData.some(function (e) {
        return e.currency_id;
    });*/
    let currencySymbol = '₹';
    currencyArray.map((item) => {
        console.log("Currency Id = ",item);
        if(item.id == currencyId)
        {
        currencySymbol = item.symbol;
        }
        });
   // console.log("Currency Id 125 = ",currencyId);

    return (
        <div>
            {linedata.simple_data && (linedata.simple_data).length !== 0 &&
                <TableContainer component={Paper}>
                    {productExist && <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                            <TableRow style={{ height:'auto'}}>
                                <StyledTableCell align="center">Quantity</StyledTableCell>
                                <StyledTableCell align="center">Product</StyledTableCell>
                                <StyledTableCell align="center">List</StyledTableCell>
                                <StyledTableCell align="center">Discount</StyledTableCell>
                                <StyledTableCell align="center">Sale Price</StyledTableCell>
                                <StyledTableCell align="center">Tax</StyledTableCell>
                                <StyledTableCell align="center">Tax Amount</StyledTableCell>
                                <StyledTableCell align="center">Total</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {linedata.simple_data.data.filter(data1 => data1.line_type === 'product').map((row, key) => (

                                <TableRow key={key}  style={{ height:'auto'}}>
                                    <StyledTableCell align="center">{parseFloat(row.product_qty).toFixed(0)}</StyledTableCell>
                                    <StyledTableCell align="center">{row.aos_products.value}</StyledTableCell>
                                    <StyledTableCell align="right">{currencySymbol}<NumberFormat value={parseFloat(row.product_list_price).toFixed(2)} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /></StyledTableCell>
                                    <StyledTableCell align="center">{row.discount === 'Amount' ? parseFloat(row.product_discount).toFixed(0) : parseFloat(row.product_discount).toFixed(0) + "%"}</StyledTableCell>
                                    <StyledTableCell align="right">{currencySymbol}<NumberFormat value={parseFloat(row.product_unit_price).toFixed(2)} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /></StyledTableCell>
                                    <StyledTableCell align="center">{parseFloat(row.vat).toFixed(0) + "%"}</StyledTableCell>
                                    <StyledTableCell align="right">{currencySymbol}<NumberFormat value={parseFloat(row.vat_amt).toFixed(2)} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /></StyledTableCell>
                                    <StyledTableCell align="right">{currencySymbol}<NumberFormat value={parseFloat(row.product_total_price).toFixed(2)} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /></StyledTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>}
                </TableContainer>
            }
            {linedata.simple_data && (linedata.simple_data).length !== 0 &&
                <TableContainer component={Paper} style={{ marginTop: '2%' }}>

                    {serviceExist && <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                            <TableRow style={{ height:'auto'}}>
                                <StyledTableCell align="center">Service</StyledTableCell>
                                <StyledTableCell align="center">List</StyledTableCell>
                                <StyledTableCell align="center">Discount</StyledTableCell>
                                <StyledTableCell align="center">Sale Price</StyledTableCell>
                                <StyledTableCell align="center">Tax</StyledTableCell>
                                <StyledTableCell align="center">Tax Amount</StyledTableCell>
                                <StyledTableCell align="center">Total</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {getData.filter(data1 => data1.line_type === 'service').map((row, key) => (
                                <TableRow key={key} style={{ height:'auto'}}>
                                    <StyledTableCell align="center">{row.name}</StyledTableCell>
                                    <StyledTableCell align="right">{currencySymbol}<NumberFormat value={parseFloat(row.product_list_price).toFixed(2)} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /></StyledTableCell>
                                    <StyledTableCell align="center">{row.discount === 'Amount' ? parseFloat(row.product_discount).toFixed(0) : parseFloat(row.product_discount).toFixed(0) + "%"}</StyledTableCell>
                                    <StyledTableCell align="right">{currencySymbol}<NumberFormat value={parseFloat(row.product_unit_price).toFixed(2)} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /></StyledTableCell>
                                    <StyledTableCell align="center">{parseFloat(row.vat).toFixed(0) + "%"}</StyledTableCell>
                                    <StyledTableCell align="right">{currencySymbol}<NumberFormat value={parseFloat(row.vat_amt).toFixed(2)} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /></StyledTableCell>
                                    <StyledTableCell align="right">{currencySymbol}<NumberFormat value={parseFloat(row.product_total_price).toFixed(2)} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /></StyledTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>}
                </TableContainer>
            }
        </div>
    );
};